<template>
  <div class="view-wrapper d-flex">
    <b-container class="main-container bg-white py-5">
      <div class="title-wrapper dark">
        <span>
          <h1 class="font-bad font-weight-bold"> 
            My Blog
          </h1>
        </span>
      </div>
    
      <main>
        <section 
          class="container">
          <div 
            @click="toggleCollapseSection"
            :class="['dropdown-title', collapseClass]">
            <h2 class="mb-0">
              <span> <i class="fab fa-vuejs mr-2"> </i> </span> 
              Vue.js </h2>
            <span>
              <i class="fas fa-chevron-down section-chevron"></i>
            </span>
          </div>
          <!--<transition name="drop">-->
            <div
              v-if="!sectionCollapsed"
              class="dropdown-content my-4"
              >      
              <ul class="content-list">
                <li class="content-list__el">
                  <router-link :to="{name:'blogComponents'}">
                    Component customization
                  </router-link>
                </li>
                <li class="content-list__el">
                  <router-link :to="{name:'blogComponents'}">
                    Slots
                  </router-link>
                </li>
              </ul>
            </div>
          <!--</transition>-->
        </section>


      </main>
    </b-container>
  </div>
</template>

<script>
export default {
  components: { 
    
  },
  data() {
    return {
      sectionCollapsed: true,
    }
  },
  created() {
  },
  methods:{
    toggleCollapseSection(){
      this.sectionCollapsed = !this.sectionCollapsed;
    }
  },
  computed:{
    collapseClass(){
      if(this.sectionCollapsed)
        return 'collapsed';
      return 'not-collapsed';
    }
  }
}
</script>
<style>
.main-nav{
  padding: 0;
}
.main-nav .container{
  padding-top: .5rem;
  padding-bottom: .5rem;
  background: #fff;
  /*box-shadow: 0 7px 14px 0 rgba(0,0,0,.16);*/
}
.custom-bg{
  /*background: url('../assets/bg/background-pattern-box.svg');*/
  background-color: #f58f7c;
  background-image: 
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 100 60'%3E%3Cg %3E%3Crect fill='%23f58f7c' width='11' height='11'/%3E%3Crect fill='%23f5907d' x='10' width='11' height='11'/%3E%3Crect fill='%23f6927f' y='10' width='11' height='11'/%3E%3Crect fill='%23f69380' x='20' width='11' height='11'/%3E%3Crect fill='%23f69482' x='10' y='10' width='11' height='11'/%3E%3Crect fill='%23f69583' y='20' width='11' height='11'/%3E%3Crect fill='%23f79784' x='30' width='11' height='11'/%3E%3Crect fill='%23f79886' x='20' y='10' width='11' height='11'/%3E%3Crect fill='%23f79987' x='10' y='20' width='11' height='11'/%3E%3Crect fill='%23f89a88' y='30' width='11' height='11'/%3E%3Crect fill='%23f89c8a' x='40' width='11' height='11'/%3E%3Crect fill='%23f89d8b' x='30' y='10' width='11' height='11'/%3E%3Crect fill='%23f89e8d' x='20' y='20' width='11' height='11'/%3E%3Crect fill='%23f9a08e' x='10' y='30' width='11' height='11'/%3E%3Crect fill='%23f9a190' y='40' width='11' height='11'/%3E%3Crect fill='%23f9a291' x='50' width='11' height='11'/%3E%3Crect fill='%23f9a392' x='40' y='10' width='11' height='11'/%3E%3Crect fill='%23faa594' x='30' y='20' width='11' height='11'/%3E%3Crect fill='%23faa695' x='20' y='30' width='11' height='11'/%3E%3Crect fill='%23faa797' x='10' y='40' width='11' height='11'/%3E%3Crect fill='%23faa898' y='50' width='11' height='11'/%3E%3Crect fill='%23fbaa99' x='60' width='11' height='11'/%3E%3Crect fill='%23fbab9b' x='50' y='10' width='11' height='11'/%3E%3Crect fill='%23fbac9c' x='40' y='20' width='11' height='11'/%3E%3Crect fill='%23fbad9e' x='30' y='30' width='11' height='11'/%3E%3Crect fill='%23fbaf9f' x='20' y='40' width='11' height='11'/%3E%3Crect fill='%23fcb0a1' x='10' y='50' width='11' height='11'/%3E%3Crect fill='%23fcb1a2' x='70' width='11' height='11'/%3E%3Crect fill='%23fcb2a3' x='60' y='10' width='11' height='11'/%3E%3Crect fill='%23fcb4a5' x='50' y='20' width='11' height='11'/%3E%3Crect fill='%23fcb5a6' x='40' y='30' width='11' height='11'/%3E%3Crect fill='%23fcb6a8' x='30' y='40' width='11' height='11'/%3E%3Crect fill='%23fdb7a9' x='20' y='50' width='11' height='11'/%3E%3Crect fill='%23fdb9ab' x='80' width='11' height='11'/%3E%3Crect fill='%23fdbaac' x='70' y='10' width='11' height='11'/%3E%3Crect fill='%23fdbbae' x='60' y='20' width='11' height='11'/%3E%3Crect fill='%23fdbcaf' x='50' y='30' width='11' height='11'/%3E%3Crect fill='%23fdbeb0' x='40' y='40' width='11' height='11'/%3E%3Crect fill='%23fdbfb2' x='30' y='50' width='11' height='11'/%3E%3Crect fill='%23fec0b3' x='90' width='11' height='11'/%3E%3Crect fill='%23fec1b5' x='80' y='10' width='11' height='11'/%3E%3Crect fill='%23fec3b6' x='70' y='20' width='11' height='11'/%3E%3Crect fill='%23fec4b8' x='60' y='30' width='11' height='11'/%3E%3Crect fill='%23fec5b9' x='50' y='40' width='11' height='11'/%3E%3Crect fill='%23fec6bb' x='40' y='50' width='11' height='11'/%3E%3Crect fill='%23fec8bc' x='90' y='10' width='11' height='11'/%3E%3Crect fill='%23fec9be' x='80' y='20' width='11' height='11'/%3E%3Crect fill='%23fecabf' x='70' y='30' width='11' height='11'/%3E%3Crect fill='%23fecbc1' x='60' y='40' width='11' height='11'/%3E%3Crect fill='%23ffcdc2' x='50' y='50' width='11' height='11'/%3E%3Crect fill='%23ffcec4' x='90' y='20' width='11' height='11'/%3E%3Crect fill='%23ffcfc5' x='80' y='30' width='11' height='11'/%3E%3Crect fill='%23ffd0c7' x='70' y='40' width='11' height='11'/%3E%3Crect fill='%23ffd2c8' x='60' y='50' width='11' height='11'/%3E%3Crect fill='%23ffd3ca' x='90' y='30' width='11' height='11'/%3E%3Crect fill='%23ffd4cb' x='80' y='40' width='11' height='11'/%3E%3Crect fill='%23ffd5cd' x='70' y='50' width='11' height='11'/%3E%3Crect fill='%23ffd7ce' x='90' y='40' width='11' height='11'/%3E%3Crect fill='%23ffd8d0' x='80' y='50' width='11' height='11'/%3E%3Crect fill='%23ffd9d1' x='90' y='50' width='11' height='11'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
<style scoped>

.dropdown-title{
  text-align: left;
   -webkit-box-shadow: 0 7px 14px 0 rgba(0,0,0,.16);
  box-shadow: 0 7px 14px 0 rgba(0,0,0,.16);
  padding: 0.8rem 1rem;
  border-radius: 0 50px 50px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #2D4057;
  cursor: pointer;
}
.dropdown-title >h2{
  font-size: 1.5rem;
}
.dropdown-title.not-collapsed .section-chevron{
  transform: rotate(180deg);
}

/* transition */
.drop-enter{
  height: 0;
}
.drop-enter-to{
  height: 220px;
}
.drop-enter-active{
  transition: height 0.5s ease-in;
}
.drop-leave{
  height: 220px;
}
.drop-leave-to{
  height: 0;
}
.drop-leave-active{
  transition: height 0.5s ease-out;
}

/* content list */
.content-list{
  padding-left: 0;
}
.content-list__el{
  list-style: none;
  text-align: left;
  
}
.content-list__el > a{
  color: inherit;
  padding: 0.5rem;
  display: block;
}
.content-list__el > a:hover{
  text-decoration: none;
  background-color: var(--gray-bg);
}


</style>